import gql from "graphql-tag";
const updateUserMutation = gql(`
mutation UpdateUsers($input: UpdateUsersInput!) {
  updateUsers(input: $input) {
    cognitoId
    credits
    tos
    conduct
    messages
    avatar
    displayname
    uuid
    nickname
    aboutme
    location
    unaliased
    subId
    userid
    created
    subType
    active
    VIP
    renewal
    subRenewal
    lastUpdate
  }
}
`)
export default updateUserMutation;
